import axios from 'axios';
export const AUTHENTICATION = process.env.VUE_APP_URLAUTHENTICATION;
export const Login = {
  // crear nueva cliente
  authenticator(payload) {
    return axios.post(AUTHENTICATION + "/users/login", payload)
  },

  restoreuser(payload) {
    return axios.post(AUTHENTICATION + "/users/restore-pass", payload)
  },

  // 2FA: el usuario ya vio "es necesario 2FA" y elige metodo (totp | email)
  chooseMfaMethod(payload) {
    return axios.post(AUTHENTICATION + "/users/mfa/choose-method", payload)
  },

  // 2FA: envia el codigo ingresado. Si es valido, la respuesta trae token/refreshtoken
  // igual que un login normal.
  verifyMfa(payload) {
    return axios.post(AUTHENTICATION + "/users/mfa/verify", payload)
  },


  //restauracion de contraseña desde el formulario de login
  async forgotPassword(username) {
    const req = await axios.post(`${AUTHENTICATION}/users/send-code-from-outside`, username);
    return req.data;
  }
}
